(function () {
  'use strict';

  /* @ngdoc object
   * @name config
   * @description
   *
   */
  angular
    .module('vcutils.config', [
      'ui.router',
      'vcutils.listeditor'
    ]);
}());
